"use strict";
/**
 * @description 无序列表/有序列表
 * @author tonghan
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var DropListMenu_1 = __importDefault(require("../menu-constructors/DropListMenu"));
var List = /** @class */ (function (_super) {
    __extends(List, _super);
    function List(editor) {
        var _this = this;
        var $elem = dom_core_1.default("<div class=\"w-e-menu\">\n                <i class=\"w-e-icon-list2\"></i>\n            </div>");
        var dropListConf = {
            width: 130,
            title: '序列',
            type: 'list',
            list: [
                {
                    $elem: dom_core_1.default("\n                        <p>\n                            <i class=\"w-e-icon-list2 w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.list.无序列表') + "\n                        <p>"),
                    value: 'insertUnorderedList',
                },
                {
                    $elem: dom_core_1.default("<p>\n                            <i class=\"w-e-icon-list-numbered w-e-drop-list-item\"></i>\n                            " + editor.i18next.t('menus.dropListMenu.list.有序列表') + "\n                        <p>"),
                    value: 'insertOrderedList',
                },
            ],
            clickHandler: function (value) {
                // 注意 this 是指向当前的 List 对象
                _this.command(value);
            },
        };
        _this = _super.call(this, $elem, editor, dropListConf) || this;
        return _this;
    }
    List.prototype.command = function (value) {
        var editor = this.editor;
        var $textElem = editor.$textElem;
        editor.selection.restoreSelection();
        // 判断是否已经执行了命令
        if (editor.cmd.queryCommandState(value)) {
            return;
        }
        //禁止在table中添加列表
        var $selectionElem = dom_core_1.default(editor.selection.getSelectionContainerElem());
        var $dom = dom_core_1.default($selectionElem.elems[0]).parentUntil('TABLE', $selectionElem.elems[0]);
        if ($dom && dom_core_1.default($dom.elems[0]).getNodeName() === 'TABLE') {
            return;
        }
        editor.cmd.do(value);
        // 验证列表是否被包裹在 <p> 之内
        if ($selectionElem.getNodeName() === 'LI') {
            $selectionElem = $selectionElem.parent();
        }
        if (/^ol|ul$/i.test($selectionElem.getNodeName()) === false) {
            return;
        }
        if ($selectionElem.equal($textElem)) {
            // 证明是顶级标签，没有被 <p> 包裹
            return;
        }
        var $parent = $selectionElem.parent();
        if ($parent.equal($textElem)) {
            // $parent 是顶级标签，不能删除
            return;
        }
        $selectionElem.insertAfter($parent);
        $parent.remove();
        // 恢复选区
        editor.selection.restoreSelection();
        this.tryChangeActive();
    };
    List.prototype.tryChangeActive = function () { };
    return List;
}(DropListMenu_1.default));
exports.default = List;
